import { get } from '../../../utils';
import { mksWhitelist, allUserActions } from './constants';

// small util funtion for getting values out of an object with a default value.
// it's a simple wrapper aroudn the get util function with additional functionality to normalize
// dtm values into expected formats.
const cherryPick = (state, path) => {
  const stateVal = get(state, path) || '';
  const normalizedStateValue = (typeof stateVal === 'string')
    ? stateVal.toLowerCase().replace(' ', '_')
    : stateVal;
  return normalizedStateValue;
}

const getVehicleYear = (state) => {
  const mlc = cherryPick(state, 'navigation.modelLineCode');
  const modelLines = cherryPick(state, 'modellines.models');
  if (!mlc || !modelLines) {
    return undefined;
  }
  const selectedModel = modelLines.find(model => model.modelLineCode === mlc.toUpperCase());
  return !selectedModel ? undefined : selectedModel.year
}

/**
 * This function returns an object that maps the redux application state into something
 * useful for DTM. If MKS is requesting more data, this would be where it needs to get added.
 * @param {Object} state This is the redux state. Passed in as a parameter to keep things pure.
 */
export const createReduxMksPageState = state => ({
  route: cherryPick(state, 'navigation.routeName'),
  vehicle: {
    modelLineCode: cherryPick(state, 'navigation.modelLineCode'),
    modelSlug: cherryPick(state, 'navigation.modelSlug'),
    nCode: cherryPick(state, 'navigation.nCode'),
    trimSlug: cherryPick(state, 'navigation.trimSlug'),
    year: getVehicleYear(state)
  },
  paymentOptions: cherryPick(state, 'bestOffers'),
  userAmounts: {
    downPayment: cherryPick(state, 'userAmounts.downPayment'),
    tradeIn: cherryPick(state, 'userAmounts.tradeIn'),
    creditRating: cherryPick(state, 'userAmounts.creditRating'),
    showAllPaymentOptions: cherryPick(state, 'userAmounts.showAllPaymentOptions'),
    paymentOfferSortMethod: cherryPick(state, 'userAmounts.paymentOfferSortMethod'),
    modelTrimSelectorOpen: cherryPick(state, 'userAmounts.modelTrimSelectorOpen'),
    monthlyPayment: cherryPick(state, 'userAmounts.monthlyPayment'),
    linkPaymentType: cherryPick(state, 'userAmounts.linkPaymentType'),
    cashBackAmount: cherryPick(state, 'userAmounts.cashBackAmount') ? cherryPick(state, 'userAmounts.cashBackAmount') : cherryPick(state, 'bestOffers.offers.bestFinanceOffer.cashBack')
  },
  dma: {
    dmaCityName: cherryPick(state, 'dma.dmaCityName'),
    dmaId: cherryPick(state, 'dma.dmaId'),
    dmaLatitude: cherryPick(state, 'dma.dmaLatitude'),
    dmaLongitude: cherryPick(state, 'dma.dmaLongitude'),
    dmaName: cherryPick(state, 'dma.dmaName'),
    dmaRegion: cherryPick(state, 'dma.dmaRegion'),
    dmaStateCode: cherryPick(state, 'dma.dmaStateCode'),
    dmaStateName: cherryPick(state, 'dma.dmaStateName'),
    zipCode: cherryPick(state, 'dma.zipCode'),
  },
  leads: cherryPick(state, 'leads'),
  dealer: cherryPick(state, 'dealer')
});

// Use allPageLayer as the default page layer selctor.
export const defaultSelector = createReduxMksPageState;

// since the majority of action types will return the same state from the redux store,
// lets just map through all the correctly prefixed actions and create default selectors.
const defaultTagsSelectors = [...allUserActions, ...mksWhitelist].map(tagSelector => ({
  type: tagSelector,
  selector: defaultSelector
}));

// only need to use this if we need some kind of new state for custom actions,
// likely unneeded, but here anyway.
const customTagSelectors = [];

// retrun the defaul and custom tag selectors
export const actionTypeSelectors = [...defaultTagsSelectors, ...customTagSelectors];



/** WEBPACK FOOTER **
 ** ./src/redux/middleware/analytics/map.js
 **/